require('./bootstrap');

window.Vue = require('vue');

window.axios = require('axios');

// Set site base path
window.domain = document.head.querySelector('meta[name="domain"]').content + '/';

/**
  * The following block of code may be used to automatically register your
  * Vue components. It will recursively scan this directory for the Vue
  * components and automatically register them with their "basename".
  *
  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
  */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('add-to-cart', require('./client/components/AddToCart.vue').default);
Vue.component('notification', require('./client/components/Notification.vue').default);
Vue.component('shopping-cart', require('./client/components/ShoppingCart.vue').default);
Vue.component('remove-icon', require('./client/components/svg/RemoveIcon.vue').default);
Vue.component('heart-icon', require('./client/components/svg/WishlistHeart.vue').default);
Vue.component('cart-icon', require('./client/components/svg/CartIcon.vue').default);
Vue.component('close-icon', require('./client/components/svg/CloseIcon.vue').default);
Vue.component('mini-cart', require('./client/components/MiniCart.vue').default);
Vue.component('side-cart', require('./client/components/SideCart.vue').default);
Vue.component('checkout-cart', require('./client/components/CheckoutCart.vue').default);
Vue.component('add-to-wishlist', require('./client/components/AddToWishlist.vue').default);
Vue.component('wishlist', require('./client/components/Wishlist.vue').default);
Vue.component('shop-product', require('./client/components/ShopProduct').default);
Vue.component('category-cart', require('./client/components/CategoryCart').default);

/**
  * Next, we will create a fresh Vue application instance and attach it to
  * the page. Then, you may begin adding components to this application
  * or customize the JavaScript scaffolding to fit your unique needs.
  */

import Toast from './client/packages/toast';
import { store } from './client/store/main.js';

Vue.use(Toast);

const app = new Vue({
  el: '#app',
  store
});


//! MAIN SCRIPTS
// *Mobile menu button
const bodyElement = document.body;
const sidenavWrapp = document.querySelector('.js_sidenav_wrapp');
const mobileMenuBtn = document.querySelector('.js_menu_btn');
const sidenavOverlay = document.querySelector('.js_sidenav_overlay');

mobileMenuBtn.addEventListener('click', () => {
  mobileMenuBtn.classList.toggle('close');
  sidenavWrapp.classList.toggle('open_sidenav');
  bodyElement.classList.toggle('no_scroll');
});

document.addEventListener('keydown', function (event) {
  if (sidenavWrapp.classList.contains('open_sidenav')) {
    const key = event.key;
    if (key === "Escape") {
      sidenavWrapp.classList.remove('open_sidenav');
      bodyElement.classList.remove('no_scroll');
    }
  }
  if (mobileMenuBtn.classList.contains('close')) {
    const key = event.key;
    if (key === "Escape") {
      mobileMenuBtn.classList.remove('close');
    }
  }
});

sidenavOverlay.addEventListener('click', () => {
  bodyElement.classList.remove('no_scroll');
  if (sidenavWrapp.classList.contains('open_sidenav')) {
    sidenavWrapp.classList.remove('open_sidenav');
  }
  if (mobileMenuBtn.classList.contains('close')) {
    mobileMenuBtn.classList.remove('close');
  }
})

// *Search
const searchWrapp = document.querySelector('.js_logo_icons');
const searchOpen = document.querySelector('.js_search_open_btn');
const searchClose = document.querySelector('.js_search_close_btn');
const searchInput = document.querySelector('#js_search_form input');

searchOpen.addEventListener('click', () => {
  searchWrapp.classList.add('search_open');
  searchInput.focus();
})

searchClose.addEventListener('click', () => {
  searchWrapp.classList.remove('search_open');
  searchInput.blur();
})

document.addEventListener('keydown', function (event) {
  if (searchWrapp.classList.contains('search_open')) {
    const key = event.key;
    if (key === "Escape") {
      searchWrapp.classList.remove('search_open');
    }
  }
});

// *Scroll to top button
const scrollToTopBtn = document.querySelector(".js_scroll_to_top_btn");

window.onscroll = () => {
  document.documentElement.scrollTop > 600 ? scrollToTopBtn.classList.add('js_to_top_show') : scrollToTopBtn
    .classList.remove('js_to_top_show');
}

scrollToTopBtn.addEventListener("click", () => {
  document.documentElement.scrollTop = 0;
});


// *Marquee Slider
let marqueeSwiper = new Swiper('.js_marquee_slider', {
  spaceBetween: 0,
  centeredSlides: true,
  speed: 6000,
  loop: true,
  slidesPerView: 'auto',
  allowTouchMove: false,
  disableOnInteraction: true,
  autoplay: {
    delay: 1
  },
});

// *STICKY navbar
const navbarSticky = document.querySelector('#js_main_header');
const navbarMenu = document.querySelector('.js_main_header');

const observer = new IntersectionObserver(function (entries) {
  // no intersection
  if (entries[0].intersectionRatio === 0) {
    navbarMenu.classList.add("js_sticky");
  }
  // fully intersects
  else if (entries[0].intersectionRatio === 1) {
    navbarMenu.classList.remove("js_sticky");
  }
}, {
  threshold: [0, 1]
});

observer.observe(navbarSticky);

// *SIDENAV MOBILE
const navMenuBtns = document.querySelectorAll('.js_nav_btn');

navMenuBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    // find closest parent li
    const navListParent = btn.closest('li');
    // inside navListParent get element with class .js_nav_item
    navListParent.querySelector('.js_nav_item').classList.toggle('open');
    btn.classList.toggle('open');
  }); 
});